import React, { FunctionComponent } from "react";

export const SidebarFooter: FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => (
  <div>
    {children}
    <style jsx>{`
      div {
        position: absolute;
        bottom: 0;
        background: var(--ant-color-bg-container);
        width: 100%;
        border-top: 1px solid var(--ant-color-border-secondary);
        padding: 10px 16px;
        text-align: right;
        left: 0;
        z-index: 3;
      }
    `}</style>
  </div>
);
